<template lang="pug">
	.creative-actions-delete(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Delete Creative
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Are you sure you want to delete creative "{{Creative.SelectedCreative.title}}"?
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="deleteCreative()") Delete creative
						button.btn.btn-ghost-dark(type="button" v-on:click="cancel()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Creative } 			from './../../services/Creative';
	import { Settings } 		from './../../services/Settings';

	export default {
		name: "CreativeDelete",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			return {

			};

		},
		methods: {
			deleteCreative() {

				Server.sendToSocket({
					DeleteCreative: Creative.SelectedCreative.id
				});

				this.hide();

			},
			cancel() {

				Broadcast.call("Show CreativeSettings");

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.creative-actions-delete
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 180px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

</style>

